/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VisibilityConditionOperator } from './VisibilityConditionOperator';
import {
    VisibilityConditionOperatorFromJSON,
    VisibilityConditionOperatorFromJSONTyped,
    VisibilityConditionOperatorToJSON,
    VisibilityConditionOperatorToJSONTyped,
} from './VisibilityConditionOperator';

/**
 * Filter condition for constraining available values
 * @export
 * @interface TableColumnFilterDto
 */
export interface TableColumnFilterDto {
    /**
     * Index of source column to check for filter condition
     * @type {number}
     * @memberof TableColumnFilterDto
     */
    sourceTableColumnIndex?: number;
    /**
     * Expected values to match in the source column
     * @type {Array<string>}
     * @memberof TableColumnFilterDto
     */
    expectedValues?: Array<string>;
    /**
     * 
     * @type {VisibilityConditionOperator}
     * @memberof TableColumnFilterDto
     */
    operator?: VisibilityConditionOperator;
}



/**
 * Check if a given object implements the TableColumnFilterDto interface.
 */
export function instanceOfTableColumnFilterDto(value: object): value is TableColumnFilterDto {
    return true;
}

export function TableColumnFilterDtoFromJSON(json: any): TableColumnFilterDto {
    return TableColumnFilterDtoFromJSONTyped(json, false);
}

export function TableColumnFilterDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TableColumnFilterDto {
    if (json == null) {
        return json;
    }
    return {
        
        'sourceTableColumnIndex': json['sourceTableColumnIndex'] == null ? undefined : json['sourceTableColumnIndex'],
        'expectedValues': json['expectedValues'] == null ? undefined : json['expectedValues'],
        'operator': json['operator'] == null ? undefined : VisibilityConditionOperatorFromJSON(json['operator']),
    };
}

export function TableColumnFilterDtoToJSON(json: any): TableColumnFilterDto {
    return TableColumnFilterDtoToJSONTyped(json, false);
}

export function TableColumnFilterDtoToJSONTyped(value?: TableColumnFilterDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sourceTableColumnIndex': value['sourceTableColumnIndex'],
        'expectedValues': value['expectedValues'],
        'operator': VisibilityConditionOperatorToJSON(value['operator']),
    };
}

